export default "__VITE_ASSET__e67c3ab2__"